export const PrimaryColor = "#068466"

export const PrimaryColorHover = "#389d85"

export const PrimaryColorLighter = "#82c1b2"

export const PrimaryColorLighter2 = "#f1f8f2"

export const GreenDark = "#5C9D52"

export const GreenDarkAdaptive = "#40081D33"

export const Red = "#EF5350"

export const RedLight = "#EF535033"

export const RedLighter = "#EF535066"

export const Blue = "#2196F3"

export const BlueLight = "#2196F333"

export const BlueLighter = "#2196F366"

export const BlueLighter2 = "#1E80F0"

export const BlueDarker = "#1d87da"

export const BlueDarker2 = "#244663"

export const YellowA = "#FFF9B3"

export const YellowMiB = "rgb(254, 208, 51)"

export const OrangeMoA = "#FF8A00"

export const Orange = "#FF9800"

export const Transparent = "transparent"

export const Purple = "#8348B3"

export const TealBlue = "#00A0B9"

export const Lime = "#8BC34A"

export const White = "#FFFFFF"

export const Black = "#000000"

export const TextBlack = "#333"

export const Grey = "#9ba5b0"

export const Grey1 = "#F0F2F5"

export const Grey2 = "#E1E6EB"

export const Grey3 = "#D1D7DE"

export const Grey4 = "#BEC5CF"

export const Grey5 = "#ACB6BF"

export const Grey6 = "#9BA5B0"

export const Grey7 = "#8A95A1"

export const Grey8 = "#78838F"

export const Grey9 = "#66717D"

export const Grey10 = "#56606B"

export const Grey11 = "#454F59"

export const Grey12 = "#363F47"

export const Grey13 = "#252C33"

export const Grey14 = "#14181C"

export const GreyBackground = "#FAFAFA"

export const Tips = "#2895f0"

export const Grey2A = "#8A95A120"

export const Grey3A = "#8A95A140"

export const Grey4A = "#8A95A180"

export const PurpleKiosk = "#9D35B0"

export const antBorder = "#e8e8e8"

export const BorderAdaptive = "rgba(0, 0, 0, 0.2)"

export const TableHeadBackground = "rgba(0,0,0,0.04)"

export const Action = PrimaryColor

export const TextShadow = "rgba(0,0,0,0.06)"

export const LoyaltyProgram = "#FF809A"

export const DoordashRed = "#FF2F06"

export const DefaultButtonBackground = "#e7ebf0"

export const DataGridSubRowForeground = "#9099a3"

export const GreyBackgroundNewOrderItemButtons = "#ebeff2"

export const GrubHubColor = "rgb(222, 70, 69)"

export const UberEatsColor = "rgb(112,174,54)"

export const SeamlessColor = "rgb(172,51,47)"

export const CaviarColor = "rgb(227,118,77)"

export const WestSideEatsColor = "rgb(111,153,196)"

export const SliceColor = "rgb(199,78,59)"
export const SelectorColors = [
    "#B3261B",
    "#C72F23",
    "#D93A2C",
    "#F64939",
    "#F86A5B",
    "#FF5F2E",
    "#BD3106",
    "#D23C0B",
    "#E34810",
    "#FF7C40",
    "#BD5600",
    "#D26B00",
    "#E48000",
    "#FF9E0D",
    "#BD7A00",
    "#D29000",
    "#FFB700",
    "#E3A300",
    "#FFC107",
    "#FFD000",
    "#C5D700",
    "#B0C900",
    "#94AC00",
    "#7F9A00",
    "#698300",
    "#377F38",
    "#2D692E",
    "#53B155",
    "#429544",
    "#72C676",
    "#01544B",
    "#007A6D",
    "#00665C",
    "#009789",
    "#19B4A9",
    "#1ACFE1",
    "#00BDD6",
    "#00A0B9",
    "#008CA7",
    "#007790",
    "#47B7F8",
    "#289BF5",
    "#1E7FD8",
    "#1A6BC6",
    "#1456B1",
    "#6679CB",
    "#4759B7",
    "#2F3C87",
    "#38469A",
    "#273170",
    "#571C6A",
    "#6B2180",
    "#812896",
    "#9D33B2",
    "#B74FC7",
    "#EE649F",
    "#E9437B",
    "#CD3463",
    "#BA2B52",
    "#A42343",
    "#A68375",
    "#6A4F44",
    "#856355",
    "#594238",
    "#49372E",
    "#B8B8B8",
    "#9E9E9E",
    "#818181",
    "#6D6D6D",
    "#585858",
    "#454F59",
    "#363F47",
    "#252C33",
    "#14181C",
    "#000000",
]
